import { RArray } from "../../collections";
import { Tristate } from "../../core";
export default class DebugMaybeAvailablityVistor {
    constructor() {
        this.errors = [];
    }
    visitAvailable(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Available[${availability.unavailabilityReasons}]`];
        }
    }
    visitUnavailable(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Unavailable[${availability.unavailabilityReasons}]`];
        }
    }
    visitMaybe(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Maybe[${availability.unavailabilityReasons}]`];
        }
    }
    visitAsync(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Async[${availability.unavailabilityReasons}]`];
        }
    }
    visitBoolean(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Boolean[${availability.unavailabilityReasons}]`];
        }
    }
    visitComposite(availability) {
        const nodes = new RArray(availability.availabilities)
            .filtered((availability) => availability.isAvailable.eq(Tristate.Maybe))
            .mapOptional((availability) => {
            const vistor = new DebugMaybeAvailablityVistor();
            availability.accept(vistor);
            return vistor.errors;
        }).raw;
        this.errors = nodes.flat(); //.map(error => `Composite[${availability.unavailabilityReasons}] -> ${error}`);
    }
    visitDependent(availability) {
        const vistitor = new DebugMaybeAvailablityVistor();
        availability.dependency.accept(vistitor);
        //this.errors = vistitor.errors.map(error => `Dependency[${availability.unavailabilityReasons}] -> ${error}`)
        this.errors = vistitor.errors.map((error) => `${availability.unavailabilityReasons}(${availability.description}) -> ${error}`);
    }
    visitParametrized(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Parametrized[${availability.unavailabilityReasons}]`];
        }
    }
    visitPreorder(availability) {
        if (availability.isAvailable.eq(Tristate.Maybe)) {
            this.errors = [`Preorder(${availability.reasons.join(", ")})`];
        }
    }
}
